import { render } from "./Roster.vue?vue&type=template&id=8fcb40a0"
import script from "./Roster.vue?vue&type=script&lang=js"
export * from "./Roster.vue?vue&type=script&lang=js"

import "./Roster.vue?vue&type=style&index=0&id=8fcb40a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__